import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import IssuedLaboratoryRequestLog from './IssuedLaboratoryRequestLog';

interface Props extends BaseModalProps {
	requestId: string;
}

const IssuedLaboratoryRequestLogModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.issuedLaboratoryRequestsListItem.log'>
			<IssuedLaboratoryRequestLog requestId={props.requestId} />
		</BaseModal>
	);
};

export default IssuedLaboratoryRequestLogModal;
